import { Link } from "react-router-dom";
import { Mail, MapPin, Instagram } from "lucide-react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  
  return <footer className="bg-card border-t border-border py-12 w-full overflow-hidden">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img src="/lovable-uploads/76ebc92c-2231-4c7b-98bf-254356462622.png" alt="Masshappy logo" className="h-8 w-auto object-contain" width={28} height={32} />
              <span className="text-xl text-primary font-poppins">masshappy</span>
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              {t('footer.description')}
            </p>
            <div className="flex space-x-3">
              <a 
                href="https://www.instagram.com/masshappyspain/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-smooth"
                aria-label={t('footer.followInstagram')}
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
          
          {/* Para Clientes */}
          <div>
            <h4 className="font-semibold mb-4">{t('footer.forClients')}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/#terapeutas" className="hover:text-primary transition-smooth">
                  {t('footer.searchTherapists')}
                </Link>
              </li>
              <li>
                <Link to="/#app" className="hover:text-primary transition-smooth">
                  {t('footer.theApp')}
                </Link>
              </li>
              <li>
                <Link to="/retiro" className="hover:text-primary transition-smooth">
                  {t('footer.theResidency')}
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Para Terapeutas */}
          <div>
            <h4 className="font-semibold mb-4">{t('footer.forTherapists')}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/soy-terapeuta" className="hover:text-primary transition-smooth">
                  Trabaja con nosotros
                </Link>
              </li>
              <li>
                <a href="mailto:info@masshappy.com?subject=Quiero unirme como terapeuta" className="hover:text-primary transition-smooth">
                  {t('footer.registerProfile')}
                </a>
              </li>

              <li>
                <a href="mailto:regina@helvetica.digital?subject=Necesito ayuda con masshappy" className="hover:text-primary transition-smooth">
                  {t('footer.helpCenter')}
                </a>
              </li>
            </ul>
          </div>

          
          {/* Contacto */}
          <div>
            <h4 className="font-semibold mb-4">{t('footer.contact')}</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li className="flex items-center">
                <Mail className="w-4 h-4 mr-2 text-primary" />
                <a 
                  href="mailto:info@masshappy.com" 
                  className="hover:text-primary transition-smooth"
                >
                  info@masshappy.com
                </a>
              </li>
              <li className="flex items-start">
                <MapPin className="w-4 h-4 mr-2 text-primary mt-0.5" />
                <div>
                  <span>{t('footer.location')}</span>
                  <br />
                  <span className="text-xs">{t('footer.schedule')}</span>
                </div>
              </li>
              <li className="pt-2">
                <a 
                  href="mailto:info@masshappy.com?subject=Consulta desde masshappy" 
                  className="inline-flex items-center px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-smooth text-sm font-medium"
                >
                  <Mail className="w-4 h-4 mr-2" />
                  {t('footer.contactUs')}
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Section */}
        <div className="border-t border-border mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-muted-foreground">
            <p>&copy; 2024 masshappy. {t('footer.rights')}</p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/terminos" className="hover:text-primary transition-smooth">
                {t('footer.termsOfUse')}
              </Link>
              <Link to="/privacidad" className="hover:text-primary transition-smooth">
                {t('footer.privacy')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;